/**
 * The one size + colour every page-level action button uses.
 *
 * Reference: the "Create Team" button on Teams Overview. Page headers used to
 * each pick their own padding (px-3 py-1.5, px-5 py-2.5, h-10 …) and their own
 * gold (#D4AF37 with white text vs bg-yellow-500 with dark text), so the same
 * action rendered a different size on every screen. Import these instead of
 * hand-writing the classes so a new page can't drift again.
 *
 * The size is deliberately px-4 py-2 / text-sm: anything smaller renders
 * shorter than the search inputs and filter dropdowns it sits beside.
 *
 * Icons inside these buttons should use ACTION_BTN_ICON.
 */
export const ACTION_BTN_GOLD =
  "inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-yellow-500 px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm transition-colors hover:bg-yellow-600";

export const ACTION_BTN_WHITE =
  "inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:bg-slate-50";

export const ACTION_BTN_ICON = "h-4 w-4";
